<div class="create-options">
  @for (option of createOptions; track option.title) {
    <ng-container *ngIf="!option.disabled; else disabledOption">
      <a class="create-option" [routerLink]="option.route">
        <img class="icon" [src]="option.icon" [alt]="option.title" />
        <div class="content">
          <h3>{{ option.title }}</h3>
          <p>{{ option.description }}</p>
        </div>
        <img class="cta-arrow" src="/assets/icons/right-arrow-green.svg" alt="Open" />
      </a>
    </ng-container>

    <ng-template #disabledOption>
      <div class="create-option disabled">
        <img class="icon" [src]="option.icon" [alt]="option.title" />
        <div class="content">
          <h3>{{ option.title }}</h3>
          <p>{{ option.description }}</p>
        </div>
        <img class="cta-arrow" src="/assets/icons/right-arrow-green.svg" alt="Open" />
      </div>
    </ng-template>
  }
</div>